import { render, staticRenderFns } from "./ExchangeAssetAllocationPieChart.vue?vue&type=template&id=53af9d00&"
import script from "./ExchangeAssetAllocationPieChart.vue?vue&type=script&lang=js&"
export * from "./ExchangeAssetAllocationPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports